function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.5 2.99988C6.25736 2.99988 5.2674 4.8235 5.2674 5.72724V5.99997H14.7001V5.72724C14.7001 4.8235 13.2426 2.99988 12 2.99988H7.5ZM4 5.72724C4 4.22101 5.67894 1.99988 7.75 1.99988H12.25C14.3211 1.99988 16 4.22101 16 5.72724V6.45451C16 6.75576 15.6642 6.99997 15.25 6.99997H4.75C4.33579 6.99997 4 6.75576 4 6.45451V5.72724Z",
  fill: "#333333"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.24149 10.1412C1.39389 10.0149 1.59261 9.97012 1.7802 10.0199L9.94922 12.1882C9.98248 12.1971 10.0174 12.1971 10.0506 12.1883L18.2198 10.0199C18.4074 9.97012 18.6061 10.0149 18.7585 10.1412C18.9109 10.2675 19 10.4614 19 10.6667V16.4444C19 17.3036 18.3441 18 17.5349 18H2.46512C1.65596 18 1 17.3036 1 16.4444V10.6667C1 10.4614 1.08908 10.2675 1.24149 10.1412ZM2.25581 11.5205V16.4444C2.25581 16.5672 2.34952 16.6667 2.46512 16.6667H17.5349C17.6505 16.6667 17.7442 16.5672 17.7442 16.4444V11.5205L10.3555 13.4817C10.1222 13.5437 9.87796 13.5437 9.64465 13.4817L2.25581 11.5205Z",
  fill: "#333333"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1 7.75C1 6.78348 1.65596 6 2.46512 6H17.5349C18.3441 6 19 6.78349 19 7.75V12.25C19 12.6642 18.7189 13 18.3721 13C18.0253 13 17.7442 12.6642 17.7442 12.25V7.75C17.7442 7.61191 17.6505 7.5 17.5349 7.5H2.46512C2.34952 7.5 2.25581 7.61192 2.25581 7.75V12.25C2.25581 12.6642 1.97469 13 1.62791 13C1.28112 13 1 12.6642 1 12.25V7.75Z",
  fill: "#333333"
});

function SvgHandbag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandbag);
export default __webpack_public_path__ + "static/media/handbag.9bcd61ea.svg";
export { ForwardRef as ReactComponent };